import StickyNav from './_modules/StickyNav';
import Toggle from './_modules/Toggle';
import Carousel from './_modules/Carousel';
import Increment from './_modules/Increment';
import Filter from './_modules/Filter';
import Lightbox from './_modules/Lightbox';
import Tabs from './_modules/Tabs';
import Units from './_modules/Units';
import FormCountry from './_modules/formCountry';
import UTMTracking from './_modules/UTM-Tracking';
import Popup from './_modules/Popup';
import BgVideo from './_modules/BgVideo';

/* -------------------------------------------------------------------------- *
 * App Initialization *
 * -------------------------------------------------------------------------- */

// Load on every page
StickyNav.init();
Toggle.init();

if (document.querySelector('.js-carousel') !== null) {
    Carousel.init();
}

if (document.querySelector('.js-count') !== null) {
    Increment.init();
}

if (document.querySelector('.js-filter') !== null) {
    Filter.init();
}

if (document.querySelector(Lightbox.selector) !== null) {
    Lightbox.init();
}

if (document.querySelector(Tabs.selector) !== null) {
    Tabs.init();
}

if (document.querySelector(Units.selector) !== null) {
    Units.init();
}

if (document.querySelector(FormCountry.selector) !== null) {
    FormCountry.init();
}
UTMTracking.init();
Popup.init();
BgVideo.init();
